module.exports = "/images/MasterCard.svg?3e1afaa2c906b4670028b8513be26b2b";